import React from 'react';
import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faTimes } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import moment from 'moment';

const BeneficioParceiroCard = ({ parceiro, remover }) => {

    const history = useHistory();

    return (
        <div className={styles.wrapper}>
            <div className={styles.bodyCard}>
                <div className={styles.title}>
                    Classificação
                </div>
                <div className={styles.info}>
                    { parceiro.classificacao }
                </div>
                <div className={styles.title}>
                    Regional
                </div>
                <div className={styles.info}>
                    { parceiro.regional }
                </div>
                <div className={styles.title}>
                    Filial
                </div>
                <div className={styles.info}>
                    { parceiro.filial }
                </div>
                <div className={styles.title}>
                    Loja
                </div>
                <div className={styles.info}>
                    { parceiro.loja }
                </div>
                <div className={styles.title}>
                    Participante
                </div>
                <div className={styles.info}>
                    { parceiro.participanteNome }
                </div>
            </div>

            <div className={styles.actionWrapper}>
                <div></div>
                <button className={styles.editar} onClick={() => {remover(parceiro.participanteId)}}>
                    Apagar
                    <FontAwesomeIcon icon={faTimes} className={styles.icon}/>
                </button>
            </div>

        </div>
    )
}

export default BeneficioParceiroCard;